import { cn } from '@/service/utils/cn';

type TEmptyDataTextProps = {
    text: string;
    className?: string;
};

export const EmptyDataText = ({ text, className }: TEmptyDataTextProps) => (
    <div
        className={cn(
            'tx-heading-2 mx-auto w-full max-w-xs py-10 text-center text-gray-2 md:tx-large-semibold dark:text-gray-3',
            className
        )}
        data-test-id="calendar-empty-text"
    >
        {text}
    </div>
);
